var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state
    ? _c(
        "div",
        {
          staticClass: "messageBoxIndex",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.MessageBox($event)
            },
          },
        },
        _vm._l(_vm.dataListArray, function (dataList, key, index) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "messageBoxPosition",
              style: {
                top: _vm.messageBoxTop - 0 + (index * 250 + index * 20) + "px",
                width: "496px",
                height: "250px",
              },
            },
            [
              _c("div", { staticClass: "dataListTitle" }, [
                _c("div", { staticStyle: { "line-height": "44px" } }, [
                  _vm._v(_vm._s(key + "（" + dataList.length + "）")),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { flex: "1" } }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "font-size": "16px" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.allIgnore(dataList, key)
                          },
                        },
                      },
                      [_vm._v("全都忽略")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wire" }),
              _vm._v(" "),
              _c(
                "el-scrollbar",
                {
                  staticClass: "scrollbar",
                  staticStyle: { height: "78%" },
                  attrs: { native: false, noresize: false, tag: "section" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      refInFor: true,
                      staticClass: "demo-ruleForm",
                      attrs: { "label-width": "88px" },
                    },
                    _vm._l(dataList, function (val, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "frame el-fade-in-linear" },
                        [
                          val.contentJson
                            ? _c("div", { staticClass: "ruleFormTitle" }, [
                                _vm._v(_vm._s(val.title)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson &&
                          val.contentJson.location &&
                          val.contentJson.username
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "所属房屋：", prop: "pass" },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("" + val.contentJson.location)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson && val.contentJson.username
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "住户姓名：",
                                    prop: "checkPass",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("" + val.contentJson.username)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson && val.contentJson.typeName
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "设备名称：", prop: "pass" },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("" + val.contentJson.typeName)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (val.contentJson &&
                            val.contentJson.location &&
                            val.contentJson.typeName) ||
                          val.title.includes("高空抛物")
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "安装位置：",
                                    prop: "checkPass",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("" + val.contentJson.location)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson && val.contentJson.plateNumber
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "车牌号：", prop: "age" } },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s("" + val.contentJson.plateNumber)
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson && val.contentJson.notificationTime
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "通知时间：", prop: "age" } },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        "" + val.contentJson.notificationTime
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          val.contentJson
                            ? _c(
                                "div",
                                { staticClass: "but" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.neglect(dataList, i, key)
                                        },
                                      },
                                    },
                                    [_vm._v("忽略")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.submitForm(
                                            val,
                                            _vm.list,
                                            i,
                                            key
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }